import React from "react";
import { motion } from "framer-motion";

const ZocketLogo = ({ width, initialPos }) => {

    const svgVariants = {
        //   hidden: { rotate: -100 },
        visible: {
            rotate: 0,
            transition: { duration: 1 },
        },
    };

    const pathVariants = {
        hidden: {
            opacity: 0,
            pathLength: 0,
            x: `-${initialPos}`,
            y: initialPos,
        },
        visible: {
            opacity: 1,
            pathLength: 1,
            x: 0,
            y: 0,
            transition: {
                duration: 2.5,
                type: "spring",
                bounce: 0.2,
            },
        },
    };

    const pathVariant2 = {
        hidden: {
            opacity: 0,
            pathLength: 0,
            //   x: -90,
            //   y: 90,
        },
        visible: {
            opacity: 1,
            pathLength: 1.1,
            //   x: 0,
            //   y: 0,
            transition: {
                duration: 3,
                // type: "spring",
                // bounce: 0.5,
            },
        },
    };

    const thrustVariant = {
        hidden: {
            opacity: 0,
            scale: 5,
            x: `-${initialPos}`,
            y: initialPos,
        },
        visible: {
            opacity: 1,
            scale: [5, 3, 3, 5, 1],
            x: 0,
            y: 0,
            transition: {
                duration: 2.5,
                type: "spring",
                bounce: 0.2,
            },
        },
    }

    return (
        // <div style={{ width: "10rem", height: "10rem" }}>
        <motion.svg
            xmlns="http://www.w3.org/2000/svg"
            id="Layer_1"
            viewBox="0 0 150 150"
            variants={svgVariants}
            initial="hidden"
            animate="visible"
            style={{ width: width }}
        >
            <defs>
                {/* <style>.cls-1{fill:#fff;}.cls-2{fill:#0f6eff;stroke:#fff;stroke-miterlimit:10;stroke-width:.5px;}</style> */}
            </defs>
            <g id="Group_2199">
                <g id="Ellipse_185">
                    <motion.circle
                        variants={pathVariant2}
                        initial="hidden"
                        animate="visible"
                        className="cls-2"
                        cx="75"
                        cy="75"
                        r="60.8"
                    />
                </g>
            </g>
            <g>
                <motion.path
                    className="cls-1"
                    d="M71.92,97.05c-1.07-1.07-2.11-2.12-3.16-3.16-5.12-5.13-10.23-10.26-15.36-15.37-.26-.26-.24-.43-.08-.71,2.39-4.16,5.24-8,8.18-11.78,2.82-3.63,5.9-7.04,9.22-10.22,5.08-4.86,10.64-9.05,16.9-12.26,.54-.28,1.1-.52,1.63-.82,.35-.2,.59-.12,.85,.14,.75,.74,1.53,1.44,2.28,2.18,4.99,4.97,9.98,9.94,14.97,14.91,.18,.18,.24,.32,.11,.58-2.6,5.45-5.88,10.47-9.78,15.08-2.88,3.4-6.02,6.55-9.36,9.5-4.57,4.03-9.46,7.61-14.58,10.91-.52,.34-1.08,.63-1.62,.94-.06,.03-.13,.06-.23,.1Zm30.02-37.24c0-1.36-.96-2.12-1.99-1.87-.69,.17-1.03,.74-1.35,1.28-1.93,3.26-4.04,6.38-6.42,9.32-2.31,2.86-4.84,5.51-7.55,7.99-.89,.81-1.82,1.59-2.69,2.43-.66,.64-.69,1.59-.12,2.23,.64,.74,1.47,.85,2.26,.25,.61-.46,1.21-.94,1.78-1.45,3.1-2.81,6.05-5.77,8.69-9.02,2.52-3.1,4.87-6.32,6.8-9.82,.28-.5,.46-1.05,.59-1.33Z"
                    variants={pathVariants}
                    initial="hidden"
                    animate="visible"
                />
                <motion.path
                    className="cls-1"
                    d="M57.84,99.02c-.1,2.35-.99,4.32-3.02,5.55-1.69,1.03-3.46,1.95-5.26,2.76-3.08,1.37-6.21,2.61-9.32,3.88-.4,.17-.83,.28-1.26,.37-.52,.11-.79-.18-.62-.67,.54-1.52,1.04-3.06,1.68-4.54,1.29-2.99,2.64-5.96,4-8.92,.59-1.28,1.29-2.5,2.3-3.5,1.17-1.16,2.58-1.68,4.21-1.75,1.58-.07,3.04,.21,4.35,1.15,1.94,1.39,2.86,3.32,2.94,5.67Z"
                    variants={thrustVariant}
                    initial="hidden"
                    animate="visible"
                />
                <motion.path
                    className="cls-1"
                    d="M60.76,61.53c-.37,.46-.73,.93-1.1,1.39-3.06,3.86-5.97,7.83-8.59,12.01-.57,.9-.58,.89-1.55,.45-1.78-.81-3.67-1.16-5.61-1.2-2.02-.04-4.02,.09-6.11,.62,.43-.53,.77-.98,1.14-1.41,2.45-2.83,5.11-5.42,8.26-7.45,3.16-2.04,6.59-3.46,10.28-4.19,1.06-.21,2.15-.24,3.23-.36,.02,.05,.03,.09,.05,.14Z"
                    variants={pathVariants}
                    initial="hidden"
                    animate="visible"
                />
                <motion.path
                    className="cls-1"
                    d="M88.25,89.69c.21,.85,.04,1.65-.1,2.44-.98,5.56-3.49,10.37-7.22,14.57-1.63,1.84-3.37,3.59-5.29,5.13-.11,.09-.22,.17-.4,.3,.1-.8,.2-1.54,.28-2.27,.31-2.83,.43-5.64-.55-8.39-.16-.44-.32-.88-.54-1.29-.19-.36-.09-.53,.22-.74,2.22-1.48,4.46-2.92,6.63-4.48,2.24-1.61,4.39-3.32,6.58-4.99,.12-.09,.24-.18,.39-.28Z"
                    variants={pathVariants}
                    initial="hidden"
                    animate="visible"
                />
                <motion.path
                    className="cls-1"
                    d="M93.37,41.04s9-3.73,17.59-3.08c0,0,1.16,.07,1.22,1.23s.1,9.57-3.13,17.69l-15.68-15.84Z"
                    variants={pathVariants}
                    initial="hidden"
                    animate="visible"
                />
            </g>
            <script

                type="text/javascript"
                src="chrome-extension://hejbmebodbijjdhflfknehhcgaklhano/../window/testing-library.js"
            />
        </motion.svg>
        // </div>
    );
};

export default ZocketLogo;
